import { LockKeyholeIcon, UserRoundIcon } from 'lucide-react';
import { authClient } from '@/lib/auth-client';
import { AccountPasswordForm } from '@/components/account-password-form';
import { AccountProfileForm } from '@/components/account-profile-form';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function AccountPage() {
  const sessionState = authClient.useSession();
  const session = sessionState.data;

  if (!session) {
    return null;
  }

  async function handleAccountUpdated() {
    await authClient.getSession();
    await sessionState.refetch();
  }

  return (
    <section className="w-full">
      <Tabs
        defaultValue="profile"
        orientation="vertical"
        className="w-full flex-col xl:flex-row xl:gap-10"
      >
        <aside className="xl:w-[17rem]">
          <div className="xl:sticky xl:top-0">
            <TabsList
              variant="line"
              className="h-auto w-full flex-col items-stretch gap-1 rounded-none bg-transparent p-0"
            >
              <TabsTrigger
                value="profile"
                className="h-10 justify-start rounded-2xl border border-transparent bg-transparent text-foreground/80 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground data-[state=active]:border-transparent data-[state=active]:!bg-sidebar-accent data-[state=active]:!text-sidebar-accent-foreground data-[state=active]:shadow-none data-[state=active]:after:hidden dark:text-muted-foreground dark:hover:text-sidebar-accent-foreground"
              >
                <UserRoundIcon />
                Profil
              </TabsTrigger>
              <TabsTrigger
                value="security"
                className="h-10 justify-start rounded-2xl border border-transparent bg-transparent text-foreground/80 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground data-[state=active]:border-transparent data-[state=active]:!bg-sidebar-accent data-[state=active]:!text-sidebar-accent-foreground data-[state=active]:shadow-none data-[state=active]:after:hidden dark:text-muted-foreground dark:hover:text-sidebar-accent-foreground"
              >
                <LockKeyholeIcon />
                Sécurité
              </TabsTrigger>
            </TabsList>
          </div>
        </aside>

        <div className="min-w-0 flex-1">
          <TabsContent value="profile" className="mt-0">
            <AccountProfileForm
              session={session}
              onAccountUpdated={handleAccountUpdated}
              className="rounded-none border-0 bg-transparent p-0 shadow-none"
            />
          </TabsContent>

          <TabsContent value="security" className="mt-0">
            <AccountPasswordForm
              onAccountUpdated={handleAccountUpdated}
              className="rounded-none border-0 bg-transparent p-0 shadow-none"
            />
          </TabsContent>
        </div>
      </Tabs>
    </section>
  );
}
